import { render } from "./HomepageView.vue?vue&type=template&id=3cce8e76&scoped=true"
import script from "./HomepageView.vue?vue&type=script&lang=js"
export * from "./HomepageView.vue?vue&type=script&lang=js"

import "./HomepageView.vue?vue&type=style&index=0&id=3cce8e76&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cce8e76"]])

export default __exports__